module.exports = __webpack_public_path__ + "img/top.4bbb292d.png";